import React from "react";
import { styled } from "@mui/material/styles";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";

const Header = styled(DialogTitle)(() => ({
  position: "relative",
  margin: 0,
  padding: 0,
  display: "flex",
  alignItems: "center"
}));

const Title = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingTop: theme.spacing(2),
  marginLeft: 0,
  marginRight: "auto"
}));

const StyledButton = styled(Button)(({ theme }) => ({
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function SessionInvalidModal({ kind }) {
  function onLoginClick() {
    window.location.replace("https://login.mildenberger-digital.de?info=not_logged_in");
    window.location.reload();
  }

  return (
    <>
      <Header>
        <Title variant="h6" id={`${kind}-modal-title`}>
          Session abgelaufen
        </Title>
      </Header>
      <DialogContent>
        <p>Sie scheinen nicht mehr angemeldet zu sein.</p>
        <p>Bitte melden Sie sich erneut an!</p>
      </DialogContent>
      <DialogActions>
        <StyledButton variant="text" color="primary" onClick={onLoginClick}>
          Zum Login
        </StyledButton>
      </DialogActions>
    </>
  );
}

SessionInvalidModal.propTypes = {
  kind: PropTypes.string.isRequired
};

export default SessionInvalidModal;
